module.exports = __webpack_public_path__ + "static/media/vietcombank-logo.8519a15d.svg";